var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-icon',{staticClass:"sort-icon",attrs:{"md-src":'/static/images/icon-sort-arrow.svg'}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }